import BaseFolderTabs from "./BaseFolderTabs.vue";

export default BaseFolderTabs;
